const visileColumns = [
  // {
  //   title: "Rec ID",
  //   field: "RecID",
  //   locked: false,
  //   filter: "text",
  //   width: "200",
  //   show: true,
  // },
  // {
  //   title: "SSN",
  //   field: "SSN",
  //   locked: false,
  //   filter: "text",
  //   width: "200",
  //   show: true,
  // },
  {
    title: "Job Order",
    field: "JobOrder",
    locked: false,
    filter: "text",
    width: "200",
    show: true,
  },
  {
    title: "Employee No",
    field: "Employee_No",
    locked: false,
    filter: "numeric",
    customFilterType: "CustomNumericText",
    width: "200",
    show: true,
  },
  {
    title: "Employee Name",
    field: "Employee_name",
    locked: false,
    filter: "text",
    width: "220",
    show: true,
  },
  {
    title: "Dept Div Code",
    field: "DeptDiv_Code",
    locked: false,
    filter: "text",
    width: "140",
    show: true,
  },
  {
    title: "Work Date",
    field: "WorkDate",
    locked: false,
    filter: "date",
    format: "MM/DD/yyyy",
    editor: "date",
    width: 180,
    show: true,
  },
  {
    title: "Work From",
    field: "WorkFrom",
    locked: false,
    filter: "text",
    width: "160",
    show: true,
  },
  {
    title: "Work To",
    field: "WorkTo",
    locked: false,
    filter: "text",
    width: "160",
    show: true,
  },
  {
    title: "Pay Code",
    field: "PayCode",
    locked: false,
    filter: "text",
    width: "160",
    show: true,
  },

  {
    title: "Check Date",
    field: "Check_Date",
    locked: false,
    filter: "date",
    format: "MM/DD/yyyy",
    editor: "date",
    width: 180,
    show: true,
  },
  {
    title: "Check Sequence",
    field: "Check_Sequence",
    locked: false,
    filter: "numeric",
    width: "160",
    show: true,
  },
  {
    title: "Verify",
    field: "verify",
    locked: false,
    filter: "numeric",
    width: "160",
    show: true,
  },
  {
    title: "Multi",
    field: "Multi",
    locked: false,
    filter: "numeric",
    width: "160",
    show: true,
  },
  {
    title: "Gross Amount",
    field: "GrossAmount",
    className: "text-end",
    headerClassName: "number-align",
    format: "c2",
    locked: false,
    filter: "numeric",
    editor: "numeric",
   width: "200",
    show: true,
  },
  {
    title: "Rate",
    field: "Rate",
    className: "text-end",
    headerClassName: "number-align",
    format: "c2",
    locked: false,
    filter: "numeric",
    editor: "numeric",
   width: "200",
    show: true,
  },
  {
    title: "PPE",
    field: "PPE",
    locked: false,
    filter: "numeric",
    width: "160",
    show: true,
  },
  {
    title: "Total Minutes",
    field: "TotalMinutes",
    locked: false,
    filter: "numeric",
    width: "200",
    show: true,
  },
  {
    title: "Total Hours",
    field: "TotalHours",
    locked: false,
    filter: "numeric",
    width: "200",
    show: true,
  },
  {
    title: "Record Type",
    field: "RecordType",
    locked: false,
    filter: "text",
    width: "160",
    show: true,
  },
  {
    title: "Quarter Check Date Calendar",
    field: "Quarter_Check_Date_Calendar",
    locked: false,
    filter: "text",
    width: "200",
    show: true,
  },
  {
    title: "Year Check Date Calendar",
    field: "Year_Check_Date_Calendar",
    locked: false,
    filter: "text",
    width: "200",
    show: true,
  },
  {
    title: "Quarter Check Date Fiscal",
    field: "Quarter_Check_Date_Fiscal",
    locked: false,
    filter: "text",
    width: "200",
    show: true,
  },
  {
    title: "Year Check Date Fiscal",
    field: "Year_Check_Date_Fiscal",
    locked: false,
    filter: "text",
    width: "200",
    show: true,
  },
];

export default visileColumns;
